import { dateToShow } from '@/helpers/dates'
import moment from 'moment'

export default {
  prepareShow (lock) {
    lock.time_start = moment(lock.date_start).format('HH:mm')
    lock.time_end = moment(lock.date_end).format('HH:mm')

    lock.date_start = dateToShow(lock.date_start) + ' ' + lock.time_start
    lock.date_end = dateToShow(lock.date_end) + ' ' + lock.time_end

    return lock
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/resources/methods.js